export enum SettingsGroup {
    Basic = 'Basic',
    Advanced = 'Advanced',
}
